
import { useEffect } from "react";
import useVendorStore from "../../HomePage/useVendorStore";
import FilterMultiSelect from "components/shared/TableWithFilters/FilterMultiSelect";

export default function WarehouseMultiSelectBox({ selected, onToggle }) {
  const warehouseList = useVendorStore((state) => state.warehouseList);
  const warehouseListLoading = useVendorStore((state) => state.warehouseListLoading);
  const fetchWarehouseData = useVendorStore((state) => state.fetchWarehouseData);

  useEffect(() => {
    if (warehouseList.length === 0 && !warehouseListLoading) {
      const outletId = window.localStorage.getItem("outlet_id");
      fetchWarehouseData({ vendor_id: parseInt(outletId, 10) });
    }
  }, []);

  const options = warehouseList.map((warehouse) => ({
    value: warehouse?.warehouse_code,
    label: `${warehouse?.warehouse_code}` + ( warehouse?.warehouse_city && `, ${warehouse?.warehouse_city}`),
  }));

  return (
    <FilterMultiSelect
      options={options}
      selected={selected}
      onToggle={onToggle}
      placeholder="Select location"
      searchable={true}
    />
  );
}
